import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';

import { RemoveBehaviorIdTokenPipeModule } from '@spog-ui/shared/pipes/remove-behavior-id-token';
import { BehaviorSelectComponent } from './behavior-select.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    RemoveBehaviorIdTokenPipeModule,
  ],
  declarations: [BehaviorSelectComponent],
  exports: [BehaviorSelectComponent],
})
export class BehaviorSelectComponentModule {}
